<template>
  <div>
    <el-drawer
      :destroy-on-close="true"
      :append-to-body="true"
      title="Ayarlar"
      :visible.sync="settings"
      :with-header="false"
    >
      <div class="row" style="padding: 50px">
        <div class="col-md-12">
          <label for="">{{ $t("module.level") }}</label>
          <el-slider
            v-model="level"
            :step="1"
            :min="2"
            :max="5"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">{{
            $t("module.autolevel")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="autoLevel"
            :active-text="$t('module.yes')"
            :active-value="1"
            :inactive-value="0"
            :inactive-text="$t('module.no')"
          >
          </el-switch>
        </div>
      </div>
    </el-drawer>
    <div id="goz_esnetme">
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>
      <div
        style="
          width: 100%;
          height: 100%;
          background-color: #3e3e3e;
          z-index: 9999999999;
          padding: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
        "
        v-if="counter == 0"
      >
        <h1
          style="
            color: white;
            font-size: 36px;
            font-weight: bold;
            text-shadow: -1px 6px 10px rgb(0 0 0 / 60%);
            text-align: center;
            margin-top: 52px;
          "
        >
          <p
            v-html="
              $t('module.timeisend', {
                point: imageStack.reduce(
                  (counter, item) =>
                    (counter += images.find((x) => x.image == item).height),
                  0
                ),
              })
            "
          ></p>
          <a
            href="javascript:;"
            @click="begin"
            style="
              color: white;
              border-radius: 10px;
              border: 2px solid rgba(255, 255, 255, 0.5);
              font-size: 22px;
              padding: 10px 15px;
              margin-top: 30px;
              display: block;
            "
            >{{ $t("module.start_again") }}</a
          >
        </h1>
      </div>
      <a
        href="javascript:;"
        @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        "
        class="pause"
      >
        <i
          :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"
        ></i>
      </a>
      <a
        href="javascript:;"
        v-if="config == null || config == undefined"
        @click.stop="settings = true"
        class="settings"
      >
        <i class="el-icon-setting"></i>
      </a>
      <div
        v-if="counter > 0"
        style="
          width: 250px;
          text-align: center;
          font-size: 22px;
          font-weight: bold;
        "
      >
        {{
          imageStack
            .reduce(
              (counter, item) =>
                (counter += images.find((x) => x.image == item).height),
              0
            )
            .toFixed(1)
        }}
        P - {{ counter }}
      </div>
      <div
        style="
          width: 250px;
          height: 500px;
          overflow: hidden;
          position: absolute;
          left: 0px;
        "
      >
        <div
          class="left"
          style="
            width: 250px;
            position: absolute;
            bottom: 0px;
            left: 0px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            transition: 0.3s;
          "
          :style="{ bottom: bottom + 'px' }"
        >
          <img
            v-if="end"
            class="step10"
            src="/static/img/tower/top.png"
            style="width: 250px"
          />

          <img
            :class="'step' + (imageStack.length - index)"
            :src="i"
            style="width: 250px"
            v-for="(i, index) in imageStack"
          />

          <img
            v-if="!start"
            :class="'step' + (6 - i)"
            :src="'/static/img/tower2/' + i + '.png'"
            style="width: 250px; display: none"
            v-for="i in 5"
          />
        </div>
      </div>
      <div class="overlay"></div>
      <div
        class="right"
        style="
          position: absolute;
          z-index: 99999;
          width: 450px;
          height: 500px;
          background-color: rgba(255, 255, 255, 0.2);
          right: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        "
      >
        <h1
          v-if="start == false"
          style="margin: 20px; font-size: 27px; text-align: center"
        >
          {{ $t("module.siralama.desc") }}
        </h1>
        <button
          v-if="intro == false && start == false"
          class="btn btn-primary"
          @click="begin"
        >
          {{ $t("module.siralama.starat") }}
        </button>
        <div
          v-if="focus"
          class="focus"
          style="width: 30px; height: 30px; background: gray"
          :style="{ top: top - 15 + 'px', left: left - 15 + 'px' }"
        ></div>

        <div
          @click="pick(item, index)"
          v-if="focus == false"
          class="options"
          v-for="(item, index) in options"
          style="
            width: 60px;
            height: 60px;
            background-color: white;
            border-radius: 15px;
          "
          :style="{
            top: item.top + 'px',
            left: item.left + 'px',
            backgroundColor:
              item.correct == true
                ? '#dcffd6'
                : item.correct == false
                ? '#ffd6d6'
                : 'white',
          }"
        >
          {{ showOptions || item.show ? item.number : "" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import axios from "axios";
export default {
  props: ["config"],
  name: "Siralama",
  data() {
    return {
      pause: false,
      backgroundPosition: 0,
      backgroundPosition2: 0,
      step: 0,
      bottom: 0,
      intro: true,
      start: false,
      focus: false,
      top: 0,
      left: 0,
      options: [],
      willShow: 1500,
      showOptions: false,
      level: 2,
      willShowOptions: 1000,
      end: false,
      lock: false,
      tolerance: 150,
      images: [
        {
          image: "/static/img/tower2/1.png",
          height: 162,
        },
        {
          image: "/static/img/tower2/2.png",
          height: 154,
        },
        {
          image: "/static/img/tower2/3.png",
          height: 223,
        },
        {
          image: "/static/img/tower2/4.png",
          height: 94,
        },
        {
          image: "/static/img/tower2/5.png",
          height: 186,
        },
      ],
      imageStack: [],
      autoLevel: false,
      settings: false,
      autoLevel: 0,
      totalTrue: 0,
      totalFalse: 0,
      circleLevel: 1,
      circleLevels: {
        1: {
          innerRadius: 80,
          outerRadius: 300,
        },
        2: {
          innerRadius: 120,
          outerRadius: 320,
        },
        3: {
          innerRadius: 220,
          outerRadius: 500,
        },
        4: {
          innerRadius: 320,
          outerRadius: 1000,
        },
      },
      answerStack: [],
      counter: 60,
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted() {
    this.wrapper = {
      width: 450,
      height: 500,
    };

    this.interval = setInterval(() => {
      this.step += 1;

      this.bottom -= 70;

      this.backgroundPosition += 50;
      $("#goz_esnetme").css(
        "background-position",
        "0px " + this.backgroundPosition + "px"
      );
      $("#goz_esnetme .overlay").css(
        "background-position",
        "200px " + this.backgroundPosition * 0.7 + "px"
      );

      $(".step" + this.step).addClass(
        "animate__animated animate__bounceInDown"
      );
      $(".step" + this.step).css("display", "block");

      if (this.step == 5) {
        clearInterval(this.interval);
        this.intro = false;
      }
    }, 300);
  },
  computed: {
    innerRadius() {
      return this.circleLevels[this.circleLevel].innerRadius;
    },
    outerRadius() {
      return this.circleLevels[this.circleLevel].outerRadius;
    },
  },
  methods: {
    randomCircle() {
      var n = _.random(1, 9);
      var PI2 = Math.PI * 2;
      var radius = 30;
      var distFromCenter =
        this.innerRadius / 2 +
        radius +
        Math.random() *
          (this.outerRadius / 2 - this.innerRadius / 2 - radius * 2);
      var angle = Math.random() * PI2;
      var x = this.left + distFromCenter * Math.cos(angle) - 35;
      var y = this.top + distFromCenter * Math.sin(angle) - 35;
      var hit = false;
      for (var i = 0; i < this.options.length; i++) {
        var circle = this.options[i];
        var dx = circle.left - x;
        var dy = circle.top - y;
        var r = circle.radius + radius;
        if (dx * dx + dy * dy <= r * r) {
          hit = true;
        }
        if (this.overlap(x, y, 60, 60, circle.left, circle.top, 60, 60)) {
          hit = true;
        }
        if (circle.number == n) {
          hit = true;
        }
      }

      if (x < 0 || y < 0 || x > 390 || y > 440) {
        hit = true;
      }

      if (!hit) {
        this.options.push({
          number: n,
          top: y,
          left: x,
          picked: false,
          show: false,
          correct: null,
        });
      }
    },
    begin() {
      this.backgroundPosition = 0;
      this.backgroundPosition2 = 0;
      this.step = 0;
      this.bottom = 0;
      this.counter = 60;
      this.imageStack = [];
      $("#goz_esnetme img").css("display", "none");
      $("#goz_esnetme img").removeClass(
        "animate__animated animate__bounceInDown"
      );
      this.focus = true;
      this.start = true;

      this.interval = setInterval(() => {
        this.counter -= 1;
        if (this.counter == 0) {
          clearInterval(this.interval);
          axios.post("module/savePoints", {
            points: [
              {
                point: this.imageStack.reduce(
                  (counter, item) =>
                    (counter += this.images.find(
                      (x) => x.image == item
                    ).height),
                  0
                ),
                type: "dikkat",
              },
            ],
            module_id: this.$store.state.modules.find(
              (k) => k.slug == "siralama"
            ).module_id,
          });
          axios.post("module/savePoints", {
            points: [
              {
                point: this.imageStack.reduce(
                  (counter, item) =>
                    (counter += this.images.find(
                      (x) => x.image == item
                    ).height),
                  0
                ),
                type: "matematik",
              },
            ],
            module_id: this.$store.state.modules.find(
              (k) => k.slug == "siralama"
            ).module_id,
          });
        }
      }, 1000);

      this.go();
    },
    overlap: function (x1, y1, w1, h1, x2, y2, w2, h2) {
      return !(
        x1 + w1 - 1 < x2 ||
        x2 + w2 - 1 < x1 ||
        y1 + h1 - 1 < y2 ||
        y2 + h2 - 1 < y1
      );
    },
    go() {
      this.focus = true;
      this.showOptions = true;
      this.options = [];

      if (this.level == 5 && this.circleLevel == 1) {
        this.top = _.random(150, 300);
        this.left = _.random(150, 350);
      } else {
        this.top = _.random(100, 400);
        this.left = _.random(100, 350);
      }

      var x = 0;
      while (true) {
        this.randomCircle();
        x += 1;
        if (this.options.length == this.level) {
          break;
        }

        if (x > 1000) {
          console.log("50 den fazla oldu ve durduruldu", this.options);
          break;
        }
      }

      setTimeout(() => {
        this.focus = false;
        setTimeout(() => {
          this.showOptions = false;
        }, this.willShowOptions);
      }, this.willShow);
    },
    pick(item, index) {
      if (this.showOptions || this.lock) return;
      // find min value
      var min = _.minBy(
        this.options.filter((k) => k.picked == false),
        function (o) {
          return o.number;
        }
      );
      if (item.number == min.number) {
        this.options[index].picked = true;
        this.options[index].show = true;
        this.options[index].correct = true;
        new Audio("/static/correct.mp3").play();
      } else {
        new Audio("/static/incorrect.mp3").play();
        this.totalFalse += 1;
        this.options[index].show = true;

        this.options = this.options.map((k) => {
          return {
            ...k,
            show: true,
            correct: k.correct == null ? null : k.correct,
            show: true,
          };
        });

        this.options[index].correct = false;
        this.lock = true;

        setTimeout(() => {
          this.go();
          this.lock = false;
        }, 1000);
      }
      if (
        this.options.filter((k) => k.picked == true).length ==
        this.options.length
      ) {
        this.totalTrue += 1;
        setTimeout(() => {
          var index2 = this.options.findIndex((k) => k.picked == false);
          this.options[index2].picked = true;
        }, 300);
        this.step += 1;
        var r = _.random(0, 4);
        this.imageStack = [this.images[r].image, ...this.imageStack];
        if (this.step > 2) {
          this.bottom -= this.images[r].height;
        }
        this.backgroundPosition += 50;
        $("#goz_esnetme").css(
          "background-position",
          "0px " + this.backgroundPosition + "px"
        );
        $("#goz_esnetme .overlay").css(
          "background-position",
          "200px " + this.backgroundPosition * 0.7 + "px"
        );

        setTimeout(() => {
          $(".step" + this.step).css("display", "block");
          $(".step" + this.step).addClass(
            "animate__animated animate__bounceInDown"
          );
        }, 0);

        setTimeout(() => {
          this.go();
        }, 1000);
      }
    },
  },
  watch: {
    totalTrue: function () {
      this.circleLevel = Math.min(this.circleLevel + 1, 4);
      this.answerStack.push(true);
    },
    totalFalse: function () {
      this.circleLevel = Math.max(this.circleLevel - 1, 1);
      this.answerStack.push(false);
    },
    answerStack: function () {
      if (this.answerStack.filter((k) => k == false).length == 3) {
        this.answerStack = this.answerStack.filter((k) => k == true);
        this.level = Math.max(this.level - 1, 1);
      }
    },
    level: function () {
      this.circleLevel = 1;
    },
    step: function () {
      if (this.start == false && this.autoLevel == 0) return;
      if (this.step == 4) {
        this.level = 3;
      }
      if (this.step == 6) {
        this.level = 4;
      }
      if (this.step == 8) {
        this.level = 5;
      }
    },
  },
  created() {
    if (this.config != null && this.config != undefined) {
      if (this.config.level != null && this.config.level != "")
        this.level = this.config.level;
      this.autoLevel = this.config.auto_level;
    }
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  max-width: 700px;
  height: 500px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: row;
  background-image: url("/static/img/tower/clouds.png") !important;
  background-repeat: repeat-y;
  background-size: 100%;
  background-color: #8bc8e1 !important;
  background-position: 0px 0px;
  will-change: background-position;
  transition: 0.3s;
}

.overlay {
  background-image: url("/static/img/tower/clouds.png");
  background-repeat: repeat-y;
  background-size: 100%;
  background-color: #8bc8e1;
  background-position: 200px 0px;
  will-change: background-position;
  transition: 0.3s;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  opacity: 0.1;
}

.left {
  img {
    margin-bottom: -2px;
  }
}

.focus {
  animation: pulse-black 2s infinite;
  border-radius: 50%;
  position: absolute;
  left: 0px;
  top: 0px;
}

@keyframes pulse-black {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

.options {
  box-shadow: 4px 3px 0px 0px #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  position: absolute;
  cursor: pointer;
}

.options:hover {
  -webkit-box-shadow: 4px 3px 2px 0px #ddd;
  -moz-box-shadow: 4px 1px 2px 0px #ddd;
  box-shadow: 4px 3px 2px 0px #ddd;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/Siralama.vue